import React, { useState } from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Check } from 'lucide-react';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MEGAPACK NOCHES DE PAZ',
      subtitle: '5 Tomos + 5 Bonos',
      ideal: 'Ideal para: Familias que buscan el sistema base probado.',
      oldPrice: '$61.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48588077203673:1',
      buttonText: 'MEGAPACK'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MEGAPACK + RECONEXIÓN',
      subtitle: '5 Tomos + 5 Bonos + Guía de Pareja Post-Caos',
      ideal: 'Ideal para: Parejas que quieren recuperar su descanso y su conexión.',
      oldPrice: '$79.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48588081660121:1',
      buttonText: 'MEGAPACK + RECONEXIÓN',
      isPopular: true
    }
  };
  const currentPlan = plans[plan];
  return <section id="pricing" className="py-6 md:py-10 px-4 bg-navy-950 relative overflow-hidden" data-id="element-193">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194">
        <FadeIn data-id="element-195">
          <div className="text-center mb-10" data-id="element-196">
            <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-197">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-198" />
            <p className="text-gray-400 mt-6 font-medium" data-id="element-199">
              ⚠️ Después sube $5.000 ARS. No vuelve.
            </p>
            <h3 className="text-3xl md:text-5xl font-serif font-black text-white mt-10 mb-8 uppercase tracking-tight" data-id="element-200">
              ELEGÍ TU <span className="text-green-500" data-id="element-201">MEGAPACK</span>
            </h3>
          </div>

          <div className="space-y-4 mb-8" data-id="element-202">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-300 rounded-2xl p-6 md:p-8 border-2 flex items-center gap-4 md:gap-6 relative overflow-hidden ${isSelected ? 'bg-navy-900 border-green-500 shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-navy-900/50 border-navy-800 hover:border-navy-700'}`} data-id="element-203">
                  {/* Radio Indicator */}
                  <div className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${isSelected ? 'border-green-500' : 'border-gray-600'}`} data-id="element-204">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-205" />}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-206">
                    <div className="flex items-center flex-wrap gap-2 mb-1" data-id="element-207">
                      <span className="text-xl shrink-0" data-id="element-208">{p.icon}</span>
                      <h4 className="text-base md:text-xl font-bold text-white uppercase tracking-tight break-words" data-id="element-209">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="text-[10px] bg-gold-500 text-navy-900 font-black px-2 py-0.5 rounded-full" data-id="element-210">
                          ⭐
                        </span>}
                    </div>
                    <p className="text-gray-400 text-xs md:text-base mb-1 break-words" data-id="element-211">
                      {p.subtitle}
                    </p>
                    <p className="text-green-500/80 text-[10px] md:text-sm font-medium break-words" data-id="element-212">
                      {p.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0 ml-auto" data-id="element-213">
                    <p className="text-gray-500 line-through text-[10px] md:text-sm mb-1" data-id="element-214">
                      {p.oldPrice}
                    </p>
                    <p className={`text-xl md:text-4xl font-black transition-colors ${isSelected ? 'text-green-500' : 'text-white'}`} data-id="element-215">
                      {p.price}{' '}
                      <span className="text-[10px] md:text-sm font-bold text-gray-400 block md:inline" data-id="element-216">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-10" data-id="element-217">
            <a href={currentPlan.url} className="w-full bg-green-500 hover:bg-green-400 text-navy-950 font-black text-lg md:text-2xl py-5 md:py-6 px-4 rounded-2xl flex items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_rgba(34,197,94,0.3)] text-center break-words leading-tight" data-id="element-218">
              → QUIERO EL {currentPlan.buttonText}
            </a>
            <div className="flex flex-col items-center mt-6 text-gray-500 text-sm gap-2" data-id="element-219">
              <p className="flex items-center gap-2" data-id="element-220">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-221" />
                Acceso inmediato por email • Pago seguro
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};